import { queryOptions } from '@tanstack/react-query';

import type { GymFinderService } from 'app/features/leads/services/gym-finder';

type LeadDetailService = Pick<GymFinderService, 'getLead'>;

export const leadDetailQueryOptions = (service: LeadDetailService, leadId: string) =>
  queryOptions({
    queryKey: ['leads', 'detail', leadId],
    queryFn: () => service.getLead(leadId),
    refetchOnWindowFocus: false,
  });
